
<template>
    <div class="live-room-call-back">
        <Table border :columns="list" :data="tablelist" :loading="dataloading"></Table>
        <div style="margin: 10px;overflow: hidden">
            <div style="float: right;">
                <Page ref="listPage" :total="pages.total" :current="pages.page" :page-size="pages.size" show-elevator
                      show-total @on-change="changePage()"></Page>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "live-room-call-back",
        data() {
            // const validateStatus = (rule, value, callback) => {
            //     if (this.dataInfo.custom_made_cate_id === '') {
            //         callback(new Error('请选择审核状态'));
            //     } else {
            //         callback();
            //     }
            // };
            return {
                title:'',
                statusList: [
                    {id: 1, name: "通过"},
                    {id: 0, name: "待审核"},
                    {id: -1, name: "不通过"}
                ],
                pages: {
                    page: 1,
                    size: 10,
                    total: 0
                },
                loading: true,
                dataloading: true,
                showModalStatus: false,
                list: [
                    {
                        title: 'Id',
                        key: 'id',
                        fixed: 'left',
                        width: 90
                    },
                    {
                        title: "用户",
                        key: "name",
                        minWidth: 350,
                        render: (h, params) => {
                            var a = "";
                            if (params.row.user != null && params.row.user.username != null)
                                a = params.row.user.username;
                            var b = "";
                            if (params.row.name != null) b = params.row.name;
                            var c = "";
                            if (
                                params.row.userdata != null &&
                                params.row.userdata.nickname != null
                            )
                                c = params.row.userdata.nickname;
                            var d = "";
                            if (params.row.user != null && params.row.user.uuid != null)
                                d = params.row.user.uuid;
                            var e = "";
                            if (params.row.user != null && params.row.user.openid != null)
                                e = params.row.user.openid;
                            var f = "";
                            if (
                                params.row.user != null &&
                                params.row.user.map_mp_openid != null
                            )
                                f = params.row.user.map_mp_openid;
                            return h("div", [
                                h(
                                    "p",
                                    {
                                        style: {
                                            color: "#3c763d"
                                        }
                                    },
                                    "用户名：" + a
                                ),
                                h(
                                    "p",
                                    {
                                        style: {
                                            color: "#3c763d"
                                        }
                                    },
                                    "名称：" + b
                                ),
                                h(
                                    "p",
                                    {
                                        style: {
                                            color: "#3c763d"
                                        }
                                    },
                                    "昵称：" + c
                                ),
                                h(
                                    "p",
                                    {
                                        style: {
                                            color: "#337ab7"
                                        }
                                    },
                                    "用户ID：" + d
                                ),
                                h(
                                    "p",
                                    {
                                        style: {
                                            color: "#777"
                                        }
                                    },
                                    "微信ID：" + e
                                ),
                                h(
                                    "p",
                                    {
                                        style: {
                                            color: "#777"
                                        }
                                    },
                                    "小程序ID：" + f
                                )
                            ]);
                        }
                    },
                    {
                        title: '评论内容',
                        width: 200,
                        key:'comment',
                    },

                    {
                        title: '评论时间',
                        width: 180,
                        key:'created_at',
                    },
                ],
                tablelist: [],
                id: 0,
            }
        },
        created: function () {
            this.id = this.$route.params.id;
            // 取数据
            this.getTableList();
        },
        components: {},
        methods: {
            getTableList: function () {
                this.$api.liveroom.comment({live_room_callback_id: this.id,"page": this.pages.page, "size": this.pages.size}).then(res => {
                    this.dataloading = false;
                    if (res.code == 200) {
                        this.tablelist = res.result;
                        this.$Message.success(res.msg);
                    }
                });
                return;
            },
            changePage() {
                this.pages.page = this.$refs["listPage"].currentPage;
                this.getTableList();
            },

        },
    }
</script>

<style scoped>

</style>